module.exports = __webpack_public_path__ + "img/rank_2.97b76a6b.png";